import { createContainer } from "unstated-next"
import { footerData } from "./navigation/footer"
import { faqData } from "./homepage/faq"
import { registrationData } from "./homepage/registration"
import { pastSponsorData, sponsorData } from "./homepage/sponsors"
import { aboutData } from "./homepage/about"
import { sideNavData } from "./navigation/sidenav"
import { navbarData } from "./navigation/navbar"

export const ContentContainer = createContainer(() => {
  return {
    faq: faqData,
    sponsors: sponsorData,
    pastSponsors: pastSponsorData,
    registration: registrationData,
    footer: footerData,
    about: aboutData,
    sideNavData: sideNavData,
    navbar: navbarData
  }
})

export const useContent = ContentContainer.useContainer
